import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

import axios from "axios";
import vueAxios from "vue-axios";

// axios.defaults.baseURL = "http://localhost:8081/api";
// axios.defaults.baseURL = "https://api2.wingjoy.cn/admin";
axios.defaults.baseURL = "https://api.wing2life.com/admin";
axios.defaults.timeout = 300000;
// 使请求带上凭证信息
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error) {
      router.replace("/login");
      ElementUI.Notification({
        title: "警告",
        message: "你没有权限这么做或服务端错误！",
        type: "warning"
      });
    }
    // 返回接口返回的错误信息
    return Promise.reject(error.response);
  }
);
Vue.use(vueAxios, axios);

// 引入 bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.js";

//引入 font-awesome
import "font-awesome/css/font-awesome.min.css";
// 完整引入 ElementUI
import ElementUI from "element-ui";

Vue.use(ElementUI);

// 引入 ElementUI 的样式文件
import "element-ui/lib/theme-chalk/index.css";

import animated from "animate.css";

Vue.use(animated);

// 如果前端没有登录信息则直接拦截，如果有则判断后端是否正常登录（防止构造参数绕过）
router.beforeEach((to, from, next) => {
  // 利用路由全局守卫，在用户已登录且访问以 /admin 开头的路径时请求菜单信息
  if (store.state.user.username && to.path.startsWith("/admin")) {
    axios.get("/login/authentication").then(() => {
      initAdminMenu(router, store);
    });
  }
  if (store.state.user.username && store.state.adminMenus.length == 0) {
    // console.log("*****************************666666666666666666***************************");
    initAdminMenu(router, store);
  }
  if (to.meta.requireAuth) {
    if (store.state.user.username) {
      axios.get("/login/authentication").then(resp => {
        if (resp) next();
      });
      // next();
    } else {
      next({
        path: "login",
        query: { redirect: to.fullPath }
      });
    }
  } else {
    next();
  }
});

// 为了保证用户确实登录，仍旧需要向后台发送一个验证请求。
// initAdminMenu 用于执行请求，调用格式化方法并向路由表中添加信息
const initAdminMenu = (router, store) => {
  // 首先判断一下 store 里有没有菜单数据，
  // 如果有说明是正常跳转，无需重新加载。（第一次进入或进行刷新时需要重新加载）
  if (store.state.adminMenus.length > 0) {
    return;
  }
  axios.get("/adminMenu/menu?username="+store.state.user.username).then(resp => {
    // console.log("$$$$$$$$$$$$$$$: "+JSON.stringify(resp));
    if (resp) {
      let fmtRoutes = formatRoutes(resp.data);
      router.addRoutes(fmtRoutes);
      store.commit("initAdminMenu", fmtRoutes);
    }
  });
  axios.get("/adminPermission/permissions?username="+store.state.user.username).then(resp => {
    // console.log("@@@@@@@@@@@@@@@@: "+JSON.stringify(resp));
    if (resp) {
      store.commit("initPermission", resp.data);
    }
  });
};

// 从后台传来的数据，需要被整理成路由能够识别的格式。
// 导航菜单倒是无所谓，赋给相应的属性就行。前端路由（router）与导航菜单需要的信息
// 进行格式转换的方法
// 参数 routes 代表从后端获取的菜单列表
const formatRoutes = routes => {
  let fmtRoutes = [];
  // 遍历这个列表，首先判断一条菜单项是否含子项，如果含则进行递归处理。
  routes.forEach(route => {
    if (route.children) {
      route.children = formatRoutes(route.children);
    }
    let fmtRoute = {
      path: route.path,
      component: resolve => {
        require([`./views/${route.component}`], resolve);
      },
      name: route.name,
      nameZh: route.nameZh,
      iconCls: route.iconCls,
      meta: {
        requireAuth: true
      },
      children: route.children
    };
    fmtRoutes.push(fmtRoute);
  });
  return fmtRoutes;
};
// noinspection JSUnusedGlobalSymbols
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
